<!-- ----------------------------------------------- -->
<template>
  <v-sheet
    v-if="this.valuesList.length != 0"
    class="print-container-column scroll-y"
    :print-style="setPrintStyle(this.itmkndCd)"
    style="width: 100%"
    v-show="valuesList"
  >
    <!-- 通常水位 -->
    <v-data-table
      v-if="this.itmkndCd === '4'"
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      item-key="cd"
      hide-default-footer
      disable-sort
      fixed-header
      class="print-container-column"
      height="100%"
    >
      <template v-slot:[`item.level`]="{ item }">
        <v-row>
          <v-col cols="4"></v-col>
          <v-col v-if="showStgHighlight(item.stgOvlvl)"
          class="tm-pc-detail-stg-ovlvl-color-highlight pa-0"
          cols="3"
          :rw-info-color="setRwInfoColor(item.stgOvlvl)">
            {{ item.stgLevel }}
          </v-col>
          <v-col v-else class="pa-0" cols="3">
            {{ item.stgLevel }}
          </v-col>
          <v-col
            class="text-left pa-0 tm-pc-detail-stage-values-tbody"
            cols="1"
          >
            <template v-if="item.stgLevelValid">
              <v-icon v-if="item.stgChg > 0" class="icon-arrow-up"
                >arrow_upward</v-icon
              >
              <v-icon v-else-if="item.stgChg === 0" class="icon-arrow-down"
                >arrow_forward</v-icon
              >
              <v-icon v-else-if="item.stgChg < 0" class="icon-arrow-down"
                >arrow_downward</v-icon
              >
            </template>
          </v-col>
          <v-col class="pa-0" cols="1">
            <v-icon v-if="item.isAbnrml" class="icon-qmflg pl-3"
              >warning</v-icon
            >
          </v-col>
          <v-col cols="3"></v-col>
        </v-row>
      </template>
    </v-data-table>
    <!-- 危機管理水位 -->
    <v-data-table
      v-else-if="this.itmkndCd === '300'"
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      item-key="cd"
      hide-default-footer
      disable-sort
      fixed-header
      height="100%"
      class="print-container-column tr"
    >
      <template v-slot:[`item.stgLevel`]="{ item }">
        <v-row>
          <v-col cols="4"></v-col>
          <v-col v-if="showSwStgHighlight(item.swstgOvlvl)"
          class="tm-pc-detail-stg-ovlvl-color-highlight pa-0"
          cols="2"
          :rw-info-color="setRwInfoColor(item.swstgOvlvl)">
            {{ item.stgLevel }}
          </v-col>
          <v-col v-else class="pa-0" cols="2">
            {{ item.stgLevel }}
          </v-col>
          <v-col class="pa-0" cols="1">
            <v-icon v-if="item.isAbnrml" class="icon-qmflg pl-3"
              >warning</v-icon
            >
          </v-col>
          <v-col cols="3"></v-col>
        </v-row>
      </template>
    </v-data-table>
    <!-- 海岸 -->
    <v-data-table
      v-else-if="this.itmkndCd === '12'"
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      item-key="cd"
      hide-default-footer
      disable-sort
      fixed-header
      height="100%"
      class="print-container-column tr"
    >
      <template v-slot:[`item.tidlvl`]="{ item }">
        <span
          v-if="showCoastHighlight(item.tidlvlovcutwrn)"
          class="tm-pc-detail-coast-ovlvl-color-highlight"
          :rw-info-color="setCoastInfoColor(item.tidlvlovcutwrn)"
        >
          {{ item.tidlvl }}
        </span>
        <span v-else> {{ item.tidlvl }} </span>
      </template>
      <template v-slot:[`item.onthwvhght`]="{ item }">
        <span
          v-if="showCoastHighlight(item.onthwvhghtcutwrn)"
          class="tm-pc-detail-coast-ovlvl-color-highlight"
          :rw-info-color="setCoastInfoColor(item.onthwvhghtcutwrn)"
        >
          {{ item.onthwvhght }}
        </span>
        <span v-else> {{ item.onthwvhght }}</span>
      </template>
      <template v-slot:[`item.wndspd`]="{ item }">
        <span
          v-if="showCoastHighlight(item.wndspdovfcutwrn)"
          class="tm-pc-detail-coast-ovlvl-color-highlight"
          :rw-info-color="setCoastInfoColor(item.wndspdovfcutwrn)"
        >
          {{ item.wndspd }}
        </span>
        <span v-else> {{ item.wndspd }} </span>
      </template>
    </v-data-table>

    <v-data-table
      v-else-if="this.itmkndCd === '6'"
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      item-key="cd"
      hide-default-footer
      disable-sort
      fixed-header
      height="100%"
      class="print-container-column tr"
    >
      <template v-slot:[`item.wtrtmp`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.wtrtmpOvcd)"
          class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.wtrtmpOvcd)"
        >
          {{ item.wtrtmp }}
        </span>
        <span v-else> {{ item.wtrtmp }} </span>
      </template>
      <template v-slot:[`item.ph`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.phOvcd)"
          class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.phOvcd)"
        >
          {{ item.ph }}
        </span>
        <span v-else> {{ item.ph }} </span>
      </template>
      <template v-slot:[`item.dox`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.doxOvcd)"
          class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.doxOvcd)"
        >
          {{ item.dox }}
        </span>
        <span v-else> {{ item.dox }} </span>
      </template>
      <template v-slot:[`item.conduct`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.conductOvcd)"
          class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.conductOvcd)"
        >
          {{ item.conduct }}
        </span>
        <span v-else> {{ item.conduct }} </span>
      </template>
      <template v-slot:[`item.turbdty`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.turbdtyOvcd)"
          class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.turbdtyOvcd)"
        >
          {{ item.turbdty }}
        </span>
        <span v-else> {{ item.turbdty }} </span>
      </template>
      <template v-slot:[`item.cod`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.codOvcd)"
          class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.codOvcd)"
        >
          {{ item.cod }}
        </span>
        <span v-else> {{ item.cod }} </span>
      </template>
      <template v-slot:[`item.amn`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.amnOvcd)"
          class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.amnOvcd)"
        >
          {{ item.amn }}
        </span>
        <span v-else> {{ item.amn }} </span>
      </template>
      <template v-slot:[`item.slt`]="{ item }">
        <span
          v-if="showWtrQualHighlight(item.sltOvcd)"
          class="tm-pc-detail-wtrqual-ovlvl-color-highlight"
          :rw-info-color="setWtrQualInfoColor(item.sltOvcd)"
        >
          {{ item.slt }}
        </span>
        <span v-else> {{ item.slt }} </span>
      </template>
    </v-data-table>
    <!-- 積雪深 -->
    <v-data-table
      v-else-if="this.itmkndCd === '3'"
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      item-key="cd"
      hide-default-footer
      disable-sort
      fixed-header
      height="100%"
      class="container-column"
    >
      <template v-slot:[`item.snwdp`]="{ item }">
        <span
          v-if="showSnowHighlight(item.snwdp)"
          class="tm-pc-detail-snow-color-highlight"
          :rw-info-color="setSnowInfoColor(item.snwdp)"
        >
          {{ item.snwdp }}
        </span>
        <span v-else> {{ item.snwdp }} </span>
      </template>
    </v-data-table>
    <!-- 通常水位・危機管理水位以外 -->
    <v-data-table
      v-else
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      item-key="cd"
      hide-default-footer
      disable-sort
      fixed-header
      height="100%"
      class="print-container-column tr"
    ></v-data-table>
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]観測値一覧印刷カード
 * PrintPreview.vue
 * @author LIS
 */
import mixin from "../../../lib/mixin.js";
export default {
  name: "print-preview",
  mixins: [mixin],
  data() {
    return {
      selectTime: "min",
      values: "【観測値一覧",
      rain: "(雨量)】",
      bsn: "(流域平均雨量)】",
      snow: "(積雪)】",
      stg: "(水位観測)】",
      qwtr: "(水質)】",
      dam: "(ダム)】",
      coast: "(海岸)】",
      rdbsn: "(レーダ流域)】",
      swstg: "(" + this.$store.state.app.config.replaceNameConfig.swstg + ")】",
    };
  },
  computed: {
    /**
     * 表示時刻設定(0:時間単位、1:10分単位) 取得
     */
    timeMode: {
      get() {
        return this.$route.query.timeMode.toLowerCase() === "true";
      },
    },
    /**
     * 観測所種別コード取得
     */
    itmkndCd: {
      get() {
        return this.$route.query.itmkndCd;
      },
    },
    /**
     * 水位表示
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /**
     * 表示フラグ
     */
    dspFlg: {
      get() {
        return this.$store.state.Telemeter.selectedTm.tmStgDetailInfo.dspFlg;
      },
    },
    /**
     * ヘッダ情報 取得
     */
    headersList: {
      get() {
        if (this.itmkndCd === "4") {
          // 通常水位の場合
          if (!this.timeMode) {
            // 10分単位
            if (this.stgMode === "1" && this.dspFlg === 1) {
              return this.min10StgHghtList.headers;
            }
            return this.min10List.headers;
          }
          // 時間単位
          if (this.stgMode === "1" && this.dspFlg === 1) {
            return this.hourStgHghtList.headers;
          }
          return this.hourList.headers;
        } else if (this.itmkndCd === "300") {
          // 危機管理水位の場合
          return this.min10List.headers;
        }

        if (!this.timeMode) {
          // 10分単位
          return this.min10List.headers;
        }
        // 時間単位
        return this.hourList.headers;
      },
    },
    /**
     * 観測値一覧 取得
     */
    valuesList: {
      get() {
        if (this.itmkndCd === "4") {
          // 通常水位の場合
          if (!this.timeMode) {
            // 10分単位
            if (this.stgMode === "1" && this.dspFlg === 1) {
              return this.min10StgHghtList.values;
            }
            return this.min10List.values;
          }
          // 時間単位
          if (this.stgMode === "1" && this.dspFlg === 1) {
            return this.hourStgHghtList.values;
          }
          return this.hourList.values;
        } else if (this.itmkndCd === "300") {
          // 危機管理水位の場合
          return this.min10List.values;
        }

        if (!this.timeMode) {
          // 10分単位
          return this.min10List.values;
        }
        // 時間単位
        return this.hourList.values;
      },
    },
    /**
     * 通常水位情報(時間) 取得
     */
    hourList: {
      get() {
        if (
          this.$store.state.Telemeter.selectedTm.obsValues.hour != undefined
        ) {
          return this.$store.state.Telemeter.selectedTm.obsValues.hour;
        }
        return null;
      },
    },
    /**
     * 通常水位情報(時間) 取得(堤防天端)
     */
    hourStgHghtList: {
      get() {
        if (
          this.$store.state.Telemeter.selectedTm.obsValues.hourStgHght !=
          undefined
        ) {
          return this.$store.state.Telemeter.selectedTm.obsValues.hourStgHght;
        }
        return null;
      },
    },
    /**
     * 通常水位情報(10分) 取得
     */
    min10List: {
      get() {
        if (this.itmkndCd === "300") {
          return this.$store.state.Swin.selectedSw.obsValues.min10;
        }
        return this.$store.state.Telemeter.selectedTm.obsValues.min10;
      },
    },
    /**
     * 通常水位情報(10分) 取得(堤防天端)
     */
    min10StgHghtList: {
      get() {
        if (
          this.$store.state.Telemeter.selectedTm.obsValues.min10StgHght !=
          undefined
        ) {
          return this.$store.state.Telemeter.selectedTm.obsValues.min10StgHght;
        }
        return null;
      },
    },
    /** 観測日時(ファイル取得用) */
    appTimeRound: {
      get() {
        return this.$store.state.app.appTimeRound;
      },
    },
    /** 観測所情報取得 */
    selectedTm: {
      get() {
        if (this.itmkndCd === "300") {
          return this.$store.state.Swin.selectedSw;
        }
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
  },
  created() {
    let obsNm, rsysNm, rvrNm, obsType;
    if (this.itmkndCd === "1") {
      // 雨量
      obsNm = this.selectedTm.tmRainDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmRainDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmRainDetailInfo.rvrNm;
      obsType = this.rain;
    } else if (this.itmkndCd === "2") {
      // 流域平均雨量
      obsNm = this.selectedTm.tmBsnDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmBsnDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmBsnDetailInfo.rvrNm;
      obsType = this.bsn;
    } else if (this.itmkndCd === "3") {
      // 積雪
      obsNm = this.selectedTm.tmSnwDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmSnwDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmSnwDetailInfo.rvrNm;
      obsType = this.snow;
    } else if (this.itmkndCd === "4") {
      // 通常水位
      obsNm = this.selectedTm.tmStgDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmStgDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmStgDetailInfo.rvrNm;
      obsType = this.stg;
    } else if (this.itmkndCd === "6") {
      // 水質
      obsNm = this.selectedTm.tmQwtrDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmQwtrDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmQwtrDetailInfo.rvrNm;
      obsType = this.qwtr;
    } else if (this.itmkndCd === "7") {
      // ダム諸量
      obsNm = this.selectedTm.tmDamDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmDamDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmDamDetailInfo.rvrNm;
      obsType = this.dam;
    } else if (this.itmkndCd === "12") {
      // 海岸
      obsNm = this.selectedTm.tmCoastDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmCoastDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmCoastDetailInfo.rvrNm;
      obsType = this.coast;
    } else if (this.itmkndCd === "20" || this.itmkndCd === "21") {
      // レーダ流域
      obsNm = this.selectedTm.tmRdBsnDetailInfo.obsNm;
      rsysNm = this.selectedTm.tmRdBsnDetailInfo.rsysNm;
      rvrNm = this.selectedTm.tmRdBsnDetailInfo.rvrNm;
      obsType = this.rdbsn;
    } else if (this.itmkndCd === "300") {
      // 危機管理水位
      obsNm = this.selectedTm.mtSwobs.obsInfo.swobsNm;
      rsysNm = this.selectedTm.mtSwobs.obsInfo.swrsysNm;
      rvrNm = this.selectedTm.mtSwobs.obsInfo.swrvrNm;
      obsType = this.swstg;
    }

    const pageName =
      this.values + obsType + obsNm + "(" + rsysNm + "水系" + rvrNm + ")";
    // 印刷用にページ名称を変更する
    this.setPageTitle(pageName);
  },
  mounted() {
    setTimeout(() => {
      window.print();
    }, 300);
    setTimeout(() => {
      window.close();
    }, 500);
  },
  methods: {
    /** 印刷プレビューCSS取得 */
    setPrintStyle(itmkndCd) {
      if (itmkndCd === "7") {
        // ダム諸量の場合
        return "dam";
      }
      return "other";
    },

     /**
     * 超過観測所 着色(水位)
     */
    setRwInfoColor(stgOvlvl) {
      if (stgOvlvl === 90) {
        return "occurrence";
      } else if (stgOvlvl === 80 || stgOvlvl === 70) {
        return "danger";
      } else if (stgOvlvl === 60 || stgOvlvl === 50) {
        return "refuge";
      } else if (stgOvlvl === 40 || stgOvlvl === 30 || stgOvlvl === 20) {
        return "warn";
      } else if (this.isFldCtl && stgOvlvl === 10) {
        // 水防団モードかつ、水防団待機水位超過
        return "standbyed";
      }
    },
    /** 超過基準水位名を表示するか(通常水位) */
    showStgHighlight(stgOvlvl) {
      if (
        (this.isFldCtl && 10 <= stgOvlvl && stgOvlvl <= 90) ||
        (!this.isFldCtl && 30 <= stgOvlvl && stgOvlvl <= 90)
      ) {
        return true;
      }
      return false;
    },
    /** 超過基準水位名を表示するか(危機管理水位) */
    showSwStgHighlight(stgOvlvl) {
      if (30 <= stgOvlvl && stgOvlvl <= 90) {
        return true;
      }
      return false;
    },
    
    /**
     * 超過観測所 着色(海岸)
     */
    setCoastInfoColor(lvlovcutwrn) {
      if (lvlovcutwrn === 2) {
        return "danger";
      } else if (lvlovcutwrn === 1) {
        return "refuge";
      }
    },
    /** 超過基準水位名を表示するか(海岸) */
    showCoastHighlight(lvlovcutwrn) {
      if (lvlovcutwrn === 1 || lvlovcutwrn === 2) {
        return true;
      }
      return false;
    },
    /**
     * 超過観測所 着色(水質)
     */
    setWtrQualInfoColor(Ovcd) {
      if (Ovcd === 1 || Ovcd === 2) {
        return "danger";
      }
    },
    /** 超過基準水位名を表示するか(水質) */
    showWtrQualHighlight(Ovcd) {
      if (Ovcd === 1 || Ovcd === 2) {
        return true;
      }
      return false;
    },
    /**
     * 超過観測所 着色(積雪)
     */
    setSnowInfoColor(snwdp) {
      if (snwdp <= 5){
        return "snwNormal";
      } else if (snwdp <= 20){
        return "snwLevel0";
      } else if (snwdp <= 50){
        return "snwLevel1";
      } else if (snwdp <= 100){
        return "snwLevel2";
      } else if (snwdp <= 150){
        return "snwLevel3";
      } else if (snwdp <= 200){
        return "snwLevel4";
      } else if (200 < snwdp){
        return "snwLevel5";
      }
    },
    /** 超過基準水位名を表示するか(積雪) */
    showSnowHighlight(snwdp) {
      if (snwdp > 0){
        return true;
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@media print {
  body,
  html {
    height: 5000px !important;
  }

  .scroll-y {
    overflow: visible !important;
    height: auto !important;
  }
}
</style>
